import InputGroup from 'components/Form/InputGroup';
import React from 'react';
import { Field } from 'react-final-form';
import { useTranslatedValidation } from 'utils/useTranslatedValidation';

interface Props {
  id: string;
  value: string;
  onChange: (v: string) => void;
}

export function PhoneCustomField(props: Props) {
  const { id, value = '', onChange } = props;
  const { isValidPhone } = useTranslatedValidation();

  return (
    <Field
      id={id}
      name={id}
      render={({ input, meta, ...rest }) => (
        <InputGroup
          {...input}
          {...rest}
          value={value}
          error={isValidPhone(value)}
          onChange={onChange}
          withoutMargin
        />
      )}
    />
  );
}
